module.exports = __webpack_public_path__ + "img/slider_4.c5e4ccd7.png";